export const MODULES = [
    {
        name: "Dashboard",
        key: "dashboard",
        permissions: [
            { label: "Dashboard View", value: "dashboard.view" }
        ]
    },
    {
        name: "User",
        key: "user",
        permissions: [
            { label: "User View", value: "user.view" },
            { label: "User Create", value: "user.create" },
            { label: "User Edit", value: "user.edit" },
            { label: "User Delete", value: "user.delete" }
        ]
    },
    {
        name: "Roles",
        key: "roles",
        permissions: [
            { label: "Roles View", value: "role.view" },
            { label: "Roles Create", value: "role.create" },
            { label: "Roles Edit", value: "role.edit" },
            { label: "Roles Delete", value: "role.delete" }
        ]
    },
    {
        name: "Event",
        key: "event",
        permissions: [
            { label: "Event View", value: "event.view" },
            { label: "Event Create", value: "event.create" },
            { label: "Event Edit", value: "event.edit" },
            { label: "Event Delete", value: "event.delete" }
        ]
    },
    {
        name: "Settings",
        key: "settings",
        permissions: [
            { label: "Settings View", value: "settings.view" },
            { label: "Settings Edit", value: "settings.edit" }
        ]
    },
];
